// Author liang gang qiang
// Date 2023-09-08 10:52:46

import * as model from "@/model/sithMesII/pds/SithMomMaterialDrawingInfoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMaterialDrawingInfo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PDS_URL,
    })
    .buildStore()
